export default {
  attended: 'Attended',
  received: 'Received',
};
